import { render, staticRenderFns } from "./result-win.vue?vue&type=template&id=2c105674&"
import script from "./result-win.vue?vue&type=script&lang=js&"
export * from "./result-win.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports